import { httpClient } from "./http-client";
import { WizardStep } from "./../common/types/wizard";
import { ParameterValue } from "../common/types/parameters";

export const getWizardSteps = async (
  customer: string | undefined,
  economicProfile: string | undefined
): Promise<WizardStep[]> => {
  const response = await httpClient.get(
    `customers/${customer}/economic-profiles/${economicProfile}/Wizard/steps`
  );

  return response?.data;
};

export const getWizardStepsByInput = async (
  customer: string | undefined,
  economicProfile: string | undefined,
  input: ParameterValue[]
): Promise<WizardStep[]> => {
  const response = await httpClient.post(
    `customers/${customer}/economic-profiles/${economicProfile}/Wizard/steps`,
    input
  );

  return response?.data;
};
